/* Replay Pocket — small enhancements (offer picker: 1 console + case add-on / duo + free cases, delivery estimate, sticky buy button, Add to cart -> drawer) */
(function () {
  var BUY_LABEL = 'Add to cart';
  try { if (window.variantStrings) window.variantStrings.addToCart = BUY_LABEL; } catch (e) {}

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function hasPubSub() { return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; }
  function num(x, def) { var n = parseFloat(x); return isNaN(n) ? def : n; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Bundles: 1 console (+ optional case) / 2 consoles + 2 free cases, one color per console ---------- */
  var FALLBACK_COLORS = [
    [/purple|violet/i, '#cdb2ff', '#6e4bd8'], [/black|noir/i, '#55556a', '#0d0d12'], [/white|blanc/i, '#ffffff', '#d3cfc6'],
    [/red|rouge/i, '#ff7272', '#c4161c'], [/yellow|jaune/i, '#ffe676', '#e8a90c'], [/blue|bleu/i, '#8fd3ff', '#1f6fd1'],
    [/green|vert/i, '#8ff0b0', '#16a34a'], [/pink|rose/i, '#ffc2e2', '#e0479a'], [/grey|gray|gris|silver/i, '#e5e5ea', '#8a8698']
  ];
  function swatchColors(fs) {
    var map = {}, sec = fs.closest('.shopify-section, section') || document;
    sec.querySelectorAll('label.rp-sw[title]').forEach(function (l) {
      var c1 = l.style.getPropertyValue('--c1').trim(), c2 = l.style.getPropertyValue('--c2').trim();
      if (c1 && c2) map[l.getAttribute('title')] = { c1: c1, c2: c2 };
    });
    return function (title) {
      if (map[title]) return map[title];
      for (var i = 0; i < FALLBACK_COLORS.length; i++) if (FALLBACK_COLORS[i][0].test(title)) return { c1: FALLBACK_COLORS[i][1], c2: FALLBACK_COLORS[i][2] };
      return { c1: '#cfcfd8', c2: '#8a8698' };
    };
  }

  function initBundles(scope) {
    scope.querySelectorAll('[data-rp-bundles]').forEach(function (fs) {
      if (fs.dataset.ready) return; fs.dataset.ready = '1';
      var qty = fs.querySelector('[data-rp-qty]');
      var pct = { 2: num(fs.dataset.d2, 0), 3: num(fs.dataset.d3, 0) };
      var duo = num(fs.dataset.duo, 0);                           // fixed price for 2 consoles (cents), 0 = use pct
      var caseId = parseInt(fs.dataset.caseId || '', 10) || null; // protective case variant
      var casePrice = num(fs.dataset.casePrice, 0);
      var addon = fs.querySelector('[data-rp-addon]');
      var caseBox = fs.querySelector('[data-rp-case]');
      var cur = fs.dataset.currency;
      var panel = fs.querySelector('[data-rp-mix]');
      var form = document.getElementById(fs.dataset.form);
      var variants = [];
      try { variants = JSON.parse(fs.querySelector('[data-rp-variants]').textContent) || []; } catch (e) {}
      var byId = {}; variants.forEach(function (x) { byId[x.id] = x; });
      var avail = variants.filter(function (x) { return x.available; });
      var colorFor = swatchColors(fs);
      var maxUnits = fs.querySelectorAll('input[type="radio"]').length || 1;
      var unitLabel = (panel && panel.dataset.unit) || 'Console';

      function formVariantId() { var el = form && form.elements['id']; return el && el.value ? parseInt(el.value, 10) : null; }
      function usable(id) { return byId[id] && byId[id].available ? id : (avail[0] ? avail[0].id : id); }
      var main = byId[formVariantId()] || avail[0] || variants[0] || null;
      var mainPrice = main ? main.price : 0;
      var start = main ? usable(main.id) : null;
      var picks = [], touched = [];
      for (var s = 0; s < maxUnits; s++) { picks.push(start); touched.push(false); }

      function tier() { var r = fs.querySelector('input[type="radio"]:checked'); return r ? parseInt(r.value, 10) || 1 : 1; }
      function priceOf(id) { return byId[id] ? byId[id].price : mainPrice; }
      function freeCases(k) { return k > 1 && caseId && duo > 0 ? k : 0; }
      function withCase() { return tier() === 1 && !!caseId && !!caseBox && caseBox.checked; }
      function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

      function buildPanel() {
        if (!panel || !variants.length || maxUnits < 2) return;
        var html = panel.dataset.head ? '<p class="rp-mix__head">' + esc(panel.dataset.head) + '</p>' : '';
        for (var u = 0; u < maxUnits; u++) {
          html += '<div class="rp-mix__row" data-unit="' + u + '"><span class="rp-mix__lbl"><small>' + esc(unitLabel) + ' ' + (u + 1) + '</small><b data-name></b></span>' +
            '<span class="rp-mix__sws" role="radiogroup" aria-label="' + esc(unitLabel) + ' ' + (u + 1) + ' color">';
          variants.forEach(function (x) {
            var c = colorFor(x.title), label = esc(x.title) + (x.available ? '' : ' · Sold out');
            html += '<button type="button" class="rp-mix__sw" role="radio" aria-checked="false" data-id="' + x.id + '" title="' + label + '" aria-label="' + label + '"' +
              (x.available ? '' : ' disabled') + ' style="--c1:' + c.c1 + ';--c2:' + c.c2 + '"><i></i></button>';
          });
          html += '</span></div>';
        }
        panel.innerHTML = html;
        panel.addEventListener('click', function (e) {
          var b = e.target.closest('.rp-mix__sw'); if (!b || b.disabled) return;
          var u = parseInt(b.closest('[data-unit]').dataset.unit, 10);
          picks[u] = parseInt(b.dataset.id, 10); touched[u] = true;
          render();
        });
        panel.addEventListener('keydown', function (e) {
          var b = e.target.closest && e.target.closest('.rp-mix__sw'); if (!b) return;
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var list = Array.prototype.filter.call(b.parentNode.children, function (x) { return !x.disabled; });
          var i = list.indexOf(b) + (e.key === 'ArrowRight' ? 1 : -1);
          var next = list[(i + list.length) % list.length]; if (next) { e.preventDefault(); next.focus(); next.click(); }
        });
      }

      function totals(k) {
        var full = 0;
        for (var i = 0; i < k; i++) full += priceOf(picks[i]);
        if (k === 2 && duo > 0) {
          var value = full + freeCases(k) * casePrice;
          return { full: value, total: duo, each: Math.round(duo / 2) };
        }
        var disc = k > 1 ? Math.round(full * (100 - (pct[k] || 0)) / 100) : full;
        return { full: full, total: disc, each: Math.round(disc / k) };
      }
      function currentTotal() {
        var n = tier();
        if (n > 1) return totals(n).total;
        return mainPrice + (withCase() ? casePrice : 0);
      }

      function paintPrice(k) {
        var el = fs.querySelector('[data-price="' + k + '"]'); if (!el) return;
        var t = k === 1 ? { full: mainPrice, total: mainPrice, each: mainPrice } : totals(k);
        var now = el.querySelector('[data-now]');
        if (now) {
          setText(now, money(t.total, cur));
          var was = el.querySelector('[data-was]'); if (was) { setText(was, t.full > t.total ? money(t.full, cur) : ''); was.hidden = !(t.full > t.total); }
          var each = el.querySelector('[data-each]'); if (each) setText(each, money(t.each, cur));
        } else if (k === 1) {
          el.innerHTML = money(mainPrice, cur);
        } else {
          var html = money(t.total, cur) + (t.full > t.total ? '<s>' + money(t.full, cur) + '</s>' : '') + '<small>' + money(t.each, cur) + '/console</small>';
          if (el.innerHTML !== html) el.innerHTML = html;
        }
        fs.querySelectorAll('[data-save="' + k + '"]').forEach(function (s) { setText(s, money(Math.max(0, t.full - t.total), cur)); });
      }
      function paintThumbs() {
        fs.querySelectorAll('[data-rp-thumb]').forEach(function (img) {
          var key = img.getAttribute('data-rp-thumb');
          var x = key === 'main' ? main : byId[picks[parseInt(key, 10)]];
          var src = x && x.img; if (src && img.getAttribute('src') !== src) { img.setAttribute('src', src); img.removeAttribute('srcset'); }
          if (x && x.title) img.setAttribute('alt', x.title);
        });
      }

      function render() {
        var n = tier();
        if (qty) qty.value = n;
        for (var k = 1; k <= maxUnits; k++) paintPrice(k);
        fs.querySelectorAll('[data-rp-tier]').forEach(function (t) { t.classList.toggle('is-on', parseInt(t.getAttribute('data-rp-tier'), 10) === n); });
        if (addon) addon.hidden = n > 1;
        if (panel && variants.length) {
          panel.hidden = n < 2;
          panel.querySelectorAll('[data-unit]').forEach(function (row) {
            var u = parseInt(row.dataset.unit, 10);
            row.hidden = u >= n;
            var name = row.querySelector('[data-name]'), x = byId[picks[u]];
            if (name) name.textContent = x ? x.title : '';
            row.querySelectorAll('.rp-mix__sw').forEach(function (b) {
              var on = parseInt(b.dataset.id, 10) === picks[u];
              b.setAttribute('aria-checked', on ? 'true' : 'false');
              b.tabIndex = on ? 0 : -1;
            });
          });
        }
        paintThumbs();
        fs.classList.toggle('is-mix', n > 1);
        fs.classList.toggle('has-case', withCase());
        fs.dataset.tier = n;
        fs.dataset.total = money(currentTotal(), cur); // read by the Add to cart button price tag
        syncSticky();
      }

      /* Read by the Add to cart handler: null = default single-line add */
      fs.rpItems = function (defaultId) {
        var n = tier();
        if (n < 2 || !variants.length) {
          if (!withCase()) return null;
          return [{ id: defaultId, quantity: 1 }, { id: caseId, quantity: 1 }];
        }
        var counts = {}, order = [];
        for (var i = 0; i < n; i++) {
          var id = picks[i]; if (!id) return null;
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id]++;
        }
        var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
        if (freeCases(n)) items.push({ id: caseId, quantity: freeCases(n) });
        return items;
      };
      fs.rpSummary = function () {
        var n = tier();
        return { n: n, pct: pct[n] || 0, total: currentTotal(), currency: cur, main: main, cases: freeCases(n), withCase: withCase() };
      };

      fs.addEventListener('change', function (e) {
        var t = e.target;
        if (t && (t.type === 'radio' || t.hasAttribute('data-rp-case'))) render();
      });

      if (hasPubSub()) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
          var x = evt && evt.data && evt.data.variant;
          if (!x || evt.data.sectionId !== fs.dataset.section) return;
          main = byId[x.id] || { id: x.id, title: x.title, price: x.price, available: x.available };
          mainPrice = x.price;
          if (byId[x.id]) byId[x.id].price = x.price;
          if (x.available) {
            picks[0] = x.id;
            for (var u = 1; u < maxUnits; u++) if (!touched[u]) picks[u] = x.id;
          }
          render();
        });
      }

      buildPanel();
      render();
    });
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, n) {
    var d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function initEta(scope) {
    scope.querySelectorAll('[data-rp-eta]').forEach(function (el) {
      var ship = parseInt(el.dataset.ship || 1, 10), min = parseInt(el.dataset.min || 6, 10), max = parseInt(el.dataset.max || 9, 10);
      var now = new Date();
      var a = addBusinessDays(now, ship + min), b = addBusinessDays(now, ship + max);
      var f = { month: 'short', day: 'numeric' };
      var out = el.querySelector('[data-rp-eta-range]');
      if (out) out.textContent = a.toLocaleDateString('en-US', f) + ' – ' + b.toLocaleDateString('en-US', f);
    });
  }

  /* ---------- Sticky buy button ---------- */
  function syncSticky() {
    var bar = document.querySelector('[data-rp-sticky]'); if (!bar) return;
    var fs = document.querySelector('[data-rp-bundles]');
    if (!fs || !fs.rpSummary) return;
    var s = fs.rpSummary();
    var t = bar.querySelector('[data-rp-sticky-variant]'), p = bar.querySelector('[data-rp-sticky-price]');
    var cur = bar.dataset.currency || s.currency;
    if (s.n > 1) {
      if (t) t.textContent = s.n + ' consoles' + (s.cases ? ' + ' + s.cases + ' free cases' : (s.pct > 0 ? ' · Save ' + s.pct + '%' : ''));
    } else if (s.main) {
      if (t) t.textContent = s.main.title + (s.withCase ? ' + case' : '');
    }
    if (p) p.textContent = money(s.total, cur);
  }
  function initSticky() {
    var bar = document.querySelector('[data-rp-sticky]'); if (!bar) return;
    var target = document.querySelector('.product-form__submit');
    var btn = bar.querySelector('button');
    if (!target) { bar.remove(); return; }
    btn.addEventListener('click', function () {
      if (target.disabled) { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      target.click();
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
      });
    });
    io.observe(target);
    if (hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant; if (!v) return;
        var p = bar.querySelector('[data-rp-sticky-price]'); if (p) p.textContent = money(v.price, bar.dataset.currency);
        var t = bar.querySelector('[data-rp-sticky-variant]'); if (t) t.textContent = v.title;
        btn.disabled = !v.available;
        syncSticky();
      });
    }
    syncSticky();
  }

  /* ---------- Add to cart: adds to cart, then opens the cart drawer ---------- */
  function setBusy(btn, on) {
    if (!btn) return;
    btn.classList.toggle('loading', on);
    if (on) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
    var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.toggle('hidden', !on);
  }
  function showError(form, msg) {
    var wrap = form.closest('product-form'); wrap = wrap && wrap.querySelector('.product-form__error-message-wrapper');
    if (!wrap) { alert(msg); return; }
    wrap.hidden = false;
    var m = wrap.querySelector('.product-form__error-message'); if (m) m.textContent = msg;
  }
  var JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function post(path, body) {
    return fetch(root() + path, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) })
      .then(function (r) {
        if (r.ok) return r;
        return r.json().catch(function () { return { description: 'Something went wrong. Please try again.' }; }).then(function (j) { throw j; });
      });
  }
  function bundleFor(form) {
    // form.id would return the <input name="id">, so read the attribute
    var fid = form.getAttribute('id'), list = document.querySelectorAll('[data-rp-bundles]');
    for (var i = 0; i < list.length; i++) if (fid && list[i].dataset.form === fid) return list[i];
    return null;
  }
  function initBuyNow() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM' || form.getAttribute('data-type') !== 'add-to-cart-form' || !form.closest('product-form')) return;
      if (form.closest('.quick-add-modal, quick-add-modal')) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = form.querySelector('[name="add"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      var idEl = form.elements['id'];
      if (!idEl || idEl.disabled) return;
      var id = parseInt(idEl.value, 10);
      var qEl = form.elements['quantity'];
      if (qEl && qEl.length && !qEl.value) qEl = qEl[0];
      var qty = Math.max(1, parseInt(qEl ? qEl.value : 1, 10) || 1);
      // Bundles: one line per chosen color (duplicates merged) + protective cases
      var fs = bundleFor(form);
      var items = (fs && fs.rpItems && fs.rpItems(id)) || [{ id: id, quantity: qty }];
      setBusy(btn, true);
      fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { items: [] }; })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          // Same variant already in the cart (e.g. back from checkout): set its quantity instead of adding again
          var updates = {}, hasUpdates = false, adds = [];
          items.forEach(function (it) {
            var line = (cart.items || []).filter(function (i) { return i.variant_id === it.id && !i.selling_plan_allocation; })[0];
            if (line) { updates[line.key] = it.quantity; hasUpdates = true; } else adds.push(it);
          });
          var chain = Promise.resolve();
          if (adds.length) chain = chain.then(function () { return post('cart/add.js', { items: adds }); });
          if (hasUpdates) chain = chain.then(function () { return post('cart/update.js', { updates: updates }); });
          return chain;
        })
        .then(function () {
          setBusy(btn, false); var drawer = document.querySelector('cart-drawer'); if (!drawer || typeof drawer.renderContents !== 'function') { window.location.href = root() + 'cart'; return; } return fetch(root() + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: id, sections: sections }); }).catch(function () { window.location.href = root() + 'cart'; });
        })
        .catch(function (err) {
          setBusy(btn, false);
          showError(form, (err && (err.description || err.message)) || 'Something went wrong. Please try again.');
        });
    }, true);
    // Coming back from checkout with the browser "back" button: reset the button state
    window.addEventListener('pageshow', function (ev) {
      if (!ev.persisted) return;
      document.querySelectorAll('.product-form__submit.loading').forEach(function (b) { setBusy(b, false); });
    });
  }

  function boot() { initBundles(document); initEta(document); initSticky(); initBuyNow(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initBundles(e.target); initEta(e.target); });
})();
